var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OutlineButton',_vm._g(_vm._b({staticClass:"button-toggle-option",class:[{ selected: _vm.selected, 'button-block': _vm.block }],attrs:{"dense":_vm.dense}},'OutlineButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }